// French language pack
// Note: All keys are in Simplified Chinese, values are in French
// This design allows developers to use Chinese directly as keys for better understanding and maintenance

export default {
  // Computing Application Page - Computing.vue
  computing: {
    // Page titles and basic information
    '平台资产': 'Actifs de la Plateforme',
    '质押金额': 'Montant Hashrate',
    '算力周期': 'Période de Calcul',
    '天': 'Jours',
    '算力类型': 'Type de Puissance de Calcul',
    '基础算力': 'Computing de Base',
    '高级算力': 'Computing Avancé',
    '超级算力': 'Super Computing',
    '企业算力': 'Computing Entreprise',
    '高性能': 'Haute Performance',
    '标准': 'Standard',
    '经济型': 'Économique',
    '申请算力': 'Demander Computing',
    '申请解押': 'Rachat Hashrate',
    '可申请次数': 'Applications Disponibles',
    '剩余次数': 'Fois Restantes',
    '短算力类型': 'Type',
    '短算力周期': 'Periode',
    '短预计日收益': 'Quotid.',
    '短剩余次数': 'Restant',
    '短解押记录': 'Rachat',
    '短算力记录': 'Leasing',
    '短质押明细': 'Hashrate',
    '短待审': 'Attente',
    '短成功': 'Succes',
    '短失败': 'Echec',
    '短完成': 'Termine',
    '超级算力申请': 'Leasing Hashrate',

    '步骤提示租赁': 'Etape 1 Selectionnez un plan hashrate · Etape 2 Touchez "Leasing Hashrate"',
    '请选择算力方案': 'Selectionnez un plan hashrate',
    '请先选择算力方案': 'Selectionnez d abord un plan hashrate puis validez le leasing',    '算力收益等级': 'Niveaux de Rendement Computing',
    '查看算力收益等级': 'Voir les Niveaux de Rendement',
    '暂无高级算力等级数据': 'Aucune donnée de niveau de computing avancé disponible',
    '暂无超级算力等级数据': 'Aucune donnée de niveau de super computing disponible',

    // Page de Détails de l'Application Computing
    '算力详情': 'Détails du Computing',
    '基本信息': 'Informations de Base',
    '原押金额': 'Montant de Mise Initial',
    '每日收益记录': 'Enregistrements de Gains Quotidiens',
    '暂无数据': 'Aucune Donnée Disponible',

    // Computing details
    '算力类型标签': 'Type :',
    '算力周期标签': 'Période :',
    '算力类型：': 'Type :',
    '算力周期：': 'Période :',
    '预计收益：': 'Revenus :',
    '质押要求：': 'Mise en Gage :',
    '开始时间：': 'Début :',
    '结束时间：': 'Fin :',
    '立即申请': 'Postuler',

    // Status and prompts
    '申请中...': 'En cours...',
    '申请中': 'En cours...',
    '申请成功': 'Réussi',
    '申请失败': 'Échec',
    '申请失败，请重试': 'Demande échouée, veuillez réessayer',
    '余额不足': 'Solde Insuffisant',
    '请先连接钱包': 'Connecter Portefeuille',
    '算力申请成功！': 'Computing réussi !',
    '算力申请失败，请重试': 'Computing échoué, réessayer',
    '申请失败，请先解押已完成的算力订单': 'Demande échouée, veuillez d\'abord débloquer la commande de puissance de calcul terminée',
    
    // Confirmation dialog
    '确认申请': 'Confirmer la Candidature',
    '取消': 'Annuler',
    '确认': 'Confirmer',
    '您确定要申请此算力吗': 'Demander ce computing ?',
    '您确定要申请此算力吗？': 'Demander ce computing ?',
    '申请后将扣除相应的质押金额': 'Montant sera déduit',
    
    // Computing status
    '运行中': 'En Cours d\'Exécution',
    '已完成': 'Terminé',
    '待开始': 'En Attente',
    '已取消': 'Annulé',
    
    // Earnings related
    'USDC': 'USDC',
    '预计日收益': 'Revenus Quotidiens Prévus',
    '总预计收益': 'Revenus Totaux Prévus',
    '当前收益': 'Revenus Actuels',
    
    // Records and status
    '解押申请记录': 'Historique Rachat',
    '超级算力申请记录': 'Enregistrements de Demande de Super Puissance de Calcul',
    '全部': 'Tous',
    '待审核': 'En Attente',
    '成功': 'Succès',
    '失败': 'Échec',
    '正在加载记录': 'Chargement des enregistrements...',
    '暂无记录': 'Aucun enregistrement',
    '解押金额': 'Montant Rachat',
    '申请天数': 'Jours de Candidature',
    '金额': 'Montant',

    // Modal related
    '选择周期': 'Période Sélectionnée',
    '收益率': 'Taux de Rendement',
    '申请金额': 'Montant de la Candidature',
    '请输入申请金额': 'Veuillez saisir le montant de la candidature',
    '最大可申请金额': 'Montant maximum applicable',
    '投入限额': 'Limite d\'Investissement',
    '最低投入': 'Investissement Minimum',
    '最大投入': 'Investissement Maximum',
    '短投入限额': 'Limite',
    '请输入有效的申请金额': 'Veuillez saisir un montant de candidature valide',
    '申请金额不能低于最低投入': 'Le montant de la candidature ne peut pas être inférieur à l\'investissement minimum',
    '申请金额不能高于最大投入': 'Le montant de la candidature ne peut pas dépasser l\'investissement maximum',

    // Error messages
    '网络错误，请稍后重试': 'Erreur réseau, veuillez réessayer plus tard',
    '参数错误': 'Erreur de paramètre',
    '服务器错误': 'Erreur serveur',
    '未知错误': 'Erreur inconnue',
    '质押金额不足': 'Montant de mise en gage insuffisant',
    '解押金额不能超过当前质押金额': 'Le montant de libération ne peut pas dépasser le montant de mise en gage actuel',
    '需要连接钱包才能申请算力': 'Besoin de connecter le portefeuille pour demander la puissance de calcul',
    '需要连接钱包才能申请解押': 'Besoin de connecter le portefeuille pour demander la libération',
    '申请提交成功': 'Demande soumise avec succès !',
    '申请提交失败': 'Échec de la soumission',
    '您的算力申请已提交，请等待审核': 'Votre demande de puissance de calcul a été soumise, veuillez attendre la vérification',

    // Messages d'état et d'erreur
    '登录已过期': 'Connexion expirée',
    '请重新连接钱包': 'Veuillez reconnecter le portefeuille',
    '加载失败': 'Échec du chargement',
    '无法获取解押申请记录': 'Impossible d\'obtenir les enregistrements de demande de libération',
    '您还有待审核的申请，请等待审核完成后再提交新申请': 'Vous avez une demande en attente d\'examen, veuillez attendre la fin de l\'examen avant de soumettre une nouvelle demande',
    '您还有未解押的算力订单，无法申请新的算力': 'Vous avez une commande de puissance de calcul non libérée, impossible de demander une nouvelle puissance de calcul',
    '申请次数已用完，最大申请次数': 'Limite de demandes atteinte, nombre maximum de demandes',
    '没有可解押的金额': 'Aucun montant disponible pour débloquer',
    '您已有待处理的解押申请，请等待审核': 'Vous avez déjà une demande de déblocage en attente, veuillez attendre l\'examen',

    '我的算力订单': 'Mes Commandes Hashrate',
    '总质押': 'Total Misé',
    '总收益': 'Gain Total',
    '进行中': 'Actif',
    '剩余天数': 'Jours Restants',
    '暂无算力订单': 'Aucune commande hashrate',

    // Popups liés à la connexion du portefeuille
    '钱包未连接': 'Portefeuille non connecté',
    '钱包信息错误': 'Erreur d\'information du portefeuille',
    '钱包地址无效': 'Adresse de portefeuille invalide',
    '授权已失效': 'Autorisation expirée',
    '授权检查失败': 'Vérification d\'autorisation échouée',
    '请重新授权USDC后再进行投资': 'Veuillez réautoriser USDC avant d\'investir',
    '请稍后重试或重新连接钱包': 'Veuillez réessayer plus tard ou reconnecter le portefeuille',
    '断开连接': 'Déconnecter',

    // Mappage du texte d'état
    '状态待审核': 'En Attente',
    '状态成功': 'Succès',
    '状态失败': 'Échec',
    '状态进行中': 'En Cours',
    '状态已完成': 'Terminé',
    '状态已取消': 'Annulé',
    '状态未知': 'Inconnu',

    // Lié à l'adresse du portefeuille
    '未连接钱包': 'Portefeuille non connecté',
    '地址格式错误': 'Format d\'adresse invalide',

    // Service client
    '客服功能开发中，敬请期待': 'Le service client est en développement, restez à l\'écoute !',

    // Lié aux paramètres de puissance de calcul
    '设置错误': 'Erreur de paramètres',
    '未找到对应的算力设置': 'Paramètres de puissance de calcul non trouvés',
    '无法获取算力设置': 'Impossible d\'obtenir les paramètres de puissance de calcul',

    // Lié au dégagement (nouveau)
    '解押审核中': 'Dégagement en Révision',
    '已解押': 'Dégagé',
    '确认解押': 'Confirmer le Dégagement',
    '处理中': 'En cours...',
    '解押申请已提交': 'Demande de Dégagement Soumise',
    '请等待审核处理': 'Veuillez attendre la révision',
    '解押申请失败': 'Échec de la Demande de Dégagement',
    '当前状态不允许解押': 'Le statut actuel ne permet pas le dégagement',

    // Lié aux détails de mise en gage (nouveau)
    '质押明细': 'Details Hashrate',
    '后值': 'Valeur Postérieure',
    '管理员操作': 'Opération Système',
    '暂无质押记录': 'Aucun enregistrement hashrate',
    '正在加载质押记录': 'Chargement des enregistrements hashrate...',
    '获取质押记录失败': 'Echec du chargement des enregistrements hashrate',
    '收益': 'Revenus',
    '质押': 'Hashrate',
    '解押': 'Rachat',
    '充值': 'Dépôt',
    '提现': 'Retrait',
    '奖励': 'Récompense',
    '推荐奖励': 'Récompense de Parrainage',
    '系统调整': 'Ajustement Système',
    '算力收益': 'Revenus de Calcul',
    '机器人收益': 'Revenus de Bot',

    // Messages de chargement et d\'erreur (nouveau)
    '无法获取申请详情': 'Impossible d\'obtenir les détails de la demande',
    '请检查网络连接后重试': 'Veuillez vérifier la connexion réseau et réessayer',
    '未找到可解押的算力申请': 'Aucune demande de puissance de calcul dégageable trouvée',

    // Lié au statut (nouveau)

    // Lié à la page de détails (nouveau)
    '算力申请详情': 'Détails de la Demande de Puissance de Calcul',
    '算力申请记录': 'Enregistrements des Demandes de Puissance de Calcul',
    '正在加载详情': 'Chargement des détails...',
    '申请周期': 'Période de Demande',
    '申请时间': 'Temps de Demande',
    '累计收益': 'Revenus Totaux',
    '暂无收益记录': 'Aucun enregistrement de revenus',
    '加载失败请重试': 'Échec du chargement, veuillez réessayer',
    '重新加载': 'Recharger',
    '包含累计收益': 'incluant les revenus totaux',
    '解押后资金将退回到平台资产中不再产生收益': 'Après le dégagement, les fonds seront retournés aux actifs de la plateforme et ne généreront plus de revenus.',
    '申请赎回': 'Racheter Hashrate',
    '赎回金额': 'Montant du Rachat',
    '赎回审核中': 'Rachat en Révision',
    '未到期不可赎回': 'Non rachetable avant l\'échéance',
    '暂不可赎回': 'Pas Encore Rachetable',
    '当前算力未到期': 'Le hashrate actuel n\'a pas expiré, le rachat sera disponible après l\'échéance',
    '需要连接钱包才能申请赎回': 'Veuillez connecter votre portefeuille pour demander le rachat',
    '您的赎回申请已提交，请等待审核': 'Votre demande de rachat a été soumise, veuillez attendre la révision',
    '确认赎回': 'Confirmer le rachat',
    '已赎回': 'Racheté',
    '您已有待处理的赎回申请，请等待审核': 'Vous avez déjà une demande de rachat en cours, veuillez attendre',
    '当前状态不允许赎回': 'Le statut actuel ne permet pas le rachat',
    '没有可赎回的金额': 'Aucun montant disponible pour le rachat'
  },

  // ==================== Page des Actifs - Assets.vue ====================
  assets: {
    // Actifs totaux
    '总资产': 'Actifs Totaux',
    '复制成功': 'Copié avec succès',

    // Aperçu des revenus
    '总收入': 'Revenus Totaux',
    '今日收入': 'Revenus d\'Aujourd\'hui',
    '体验金': 'Solde de Démonstration',
    '空投奖励': 'Récompenses Airdrop',

    // Boutons d'action
    '充值': 'Dépôt',
    '快速充值说明': 'Deposez rapidement des USDC',
    '提现': 'Retrait',
    '邀请': 'Inviter',
    '白皮书': 'Livre Blanc',
    '幸运轮': 'Roue de la Fortune',
    '站内信': 'Messages',
    '信用分': 'Score de Crédit',
    '快捷邀请': 'Inviter',
    '快捷白皮书': 'Whitepaper',
    '快捷幸运轮': 'Fortune',
    '快捷信用分': 'Crédit',

    // Niveau VIP
    'VIP等级': 'Niveau VIP',
    '暂无VIP等级数据': 'Aucune donnée de niveau VIP disponible',

    // Mon compte
    '我的账户': 'Mon Compte',
    '申请备用金': 'Demander un Fonds de Réserve',
    '设置资金密码': 'Définir le Mot de Passe des Fonds',
    '选择语言': 'Sélectionner la Langue',

    // Messages de log de console
    '钱包未连接，触发钱包连接': 'Portefeuille non connecté, déclenchement de la connexion du portefeuille',
    '钱包地址无效，重新连接': 'Adresse de portefeuille invalide, reconnexion',
    '钱包已连接，直接跳转到充值页面': 'Portefeuille connecté, redirection vers la page de dépôt',
    '检查授权状态失败': 'Échec de la vérification du statut d\'autorisation',
    '白皮书功能': 'Fonction livre blanc',
    '检查资金密码状态失败': 'Échec de la vérification du statut du mot de passe des fonds',

    // Logs liés à l'API
    'Token不存在，显示默认余额': 'Token n\'existe pas, affichage du solde par défaut',
    '调用API获取用户余额数据': 'Appel de l\'API pour obtenir les données de solde utilisateur...',
    '体验金加载成功': 'Solde de démonstration chargé avec succès',
    '总资产计算完成': 'Calcul des actifs totaux terminé',
    '余额': 'Solde',
    '质押金额': 'Montant Hashrate',
    'API返回失败': 'L\'API a retourné un échec',
    '加载用户余额失败': 'Échec du chargement du solde utilisateur',
    'Token不存在，显示默认收益': 'Token n\'existe pas, affichage des revenus par défaut',
    '调用API获取用户收益数据...': 'Appel de l\'API pour obtenir les données de revenus utilisateur...',
    '收益数据加载成功': 'Données de revenus chargées avec succès',
    '收益API返回失败': 'L\'API des revenus a retourné un échec',
    '加载用户收益失败': 'Échec du chargement des revenus utilisateur',
    '使用默认收益数据': 'Utilisation des données de revenus par défaut',
    '信用分加载成功': 'Score de crédit chargé avec succès',

    // Sélection de langue
    '中文（简体）': 'Chinois (Simplifié)',

    // Récompenses airdrop liées
    '钱包地址': 'Adresse du portefeuille',
    '调用API获取空投奖励数据...': '🔍 Appel API pour obtenir les données de récompenses airdrop...',

    // Service client lié
    '打开客服': 'Ouvrir service client',
    '客服功能开发中，敬请期待！': 'Fonction de service client en développement, restez à l\'écoute!',

    // Chargement de page
    '资产页面已加载': 'Page des actifs chargée'
  },

  // ==================== Page de Recharge - Recharge.vue ====================
  recharge: {
    // Titre de page et navigation
    '充值': 'Recharge',
    '返回': 'Retour',
    '充值记录': 'Historique de Recharge',

    // Titres des étapes
    '选择金额': 'Sélectionner le Montant',
    '确认订单': 'Confirmer la Commande',
    '完成转账': 'Terminer le Transfert',

    // Saisie du montant
    '请输入充值金额': 'Veuillez saisir le montant de recharge',
    '自定义': 'Personnalisé',
    '最小充值金额': 'Montant minimum de recharge',
    '最小充值金额提示': 'Minimum 500 USDC',
    '最大充值金额': 'Montant maximum de recharge',
    '下一步': 'Suivant',
    '上一步': 'Précédent',
    '开通自动转入': 'Activer le Transfert Automatique',

    // Informations de commande
    '订单信息': 'Informations de Commande',
    '订单号': 'Numéro de Commande',
    '充值金额': 'Montant de Recharge',
    '网络': 'Réseau',
    '代币': 'Token',
    '收款地址': 'Adresse de Réception',
    '创建订单': 'Créer la Commande',
    '创建中': 'Création...',

    // Connexion portefeuille
    '请先连接钱包': 'Veuillez d\'abord connecter le portefeuille',
    '未检测到钱包地址，请先连接钱包': 'Adresse de portefeuille non détectée, veuillez d\'abord connecter le portefeuille',

    // Solde
    'USDC余额不足': 'Solde USDC insuffisant! Solde actuel',
    '转账超时，请检查钱包或重试': 'Timeout de transfert, vérifiez le portefeuille ou réessayez',
    '转账成功但没有获得交易哈希，请手动提供交易哈希': 'Transfert réussi mais aucun hash de transaction reçu, veuillez fournir le hash de transaction manuellement',
    '请先连接MetaMask钱包': 'Veuillez d\'abord connecter le portefeuille MetaMask',
    '转账可能成功但无法获取交易哈希，请手动检查钱包': 'Le transfert a peut-être réussi mais impossible d\'obtenir le hash de transaction, veuillez vérifier le portefeuille manuellement',
    '交易哈希无效，请稍后在钱包历史中复制正确的交易哈希': 'Hash de transaction invalide, veuillez copier le hash correct de l\'historique du portefeuille plus tard',
    '钱包地址不存在': 'L\'adresse du portefeuille n\'existe pas',
    '交易失败': 'Transaction échouée',
    '当前网络': 'Réseau actuel',
    '请切换到以太坊主网或测试网': 'Veuillez passer au réseau principal Ethereum ou testnet',
    '请点击页面右上角网络设置，选择Ethereum，然后重新充值。': 'Veuillez cliquer sur les paramètres réseau dans le coin supérieur droit de la page, sélectionner Ethereum, puis recharger à nouveau.',
    '需要': 'Requis',
    '更新订单失败': 'Échec de mise à jour de la commande',

    // Étapes de transfert
    '请使用钱包转账': 'Veuillez utiliser le portefeuille pour transférer',
    '转账地址': 'Adresse de Transfert',
    '转账金额': 'Montant de Transfert',
    '合约地址': 'Adresse du Contrat',
    '复制地址': 'Copier l\'Adresse',
    '复制金额': 'Copier le Montant',
    '开始转账': 'Commencer le Transfert',
    '重新转账': 'Réessayer le Transfert',
    '查看详情': 'Voir les Détails',

    // Informations de statut
    '等待转账': 'En attente de transfert',
    '转账中': 'Transfert en cours',
    '确认中': 'Confirmation en cours',
    '转账成功': 'Transfert réussi',
    '转账失败': 'Transfert échoué',
    '交易哈希': 'Hash de Transaction',
    '在区块链浏览器中查看': 'Voir dans l\'explorateur blockchain',

    // Conseils
    '请确保转账金额准确': 'Veuillez vous assurer que le montant du transfert est exact',
    '请确保使用正确的网络': 'Veuillez vous assurer d\'utiliser le bon réseau',
    '转账完成后系统会自动确认': 'Le système confirmera automatiquement après la fin du transfert',
    '地址已复制': 'Adresse copiée',
    '金额已复制': 'Montant copié',
    '复制失败': 'Échec de la copie',

    // Messages d'erreur
    '金额不能为空': 'Le montant ne peut pas être vide',
    '金额必须大于': 'Le montant doit être supérieur à',
    '金额不能超过': 'Le montant ne peut pas dépasser',
    '创建订单失败': 'Échec de la création de commande',
    '转账失败，请重试': 'Transfert échoué, veuillez réessayer',
    '网络错误，请检查连接': 'Erreur réseau, veuillez vérifier la connexion',

    // MetaMask相关
    '请安装MetaMask钱包': 'Veuillez installer le portefeuille MetaMask',
    '网络检查通过': 'Vérification du réseau réussie',
    'USDC余额不足！当前余额': 'Solde USDC insuffisant ! Solde actuel : {balance} USDC, requis : {amount} USDC',
    '余额检查通过': '✅ Vérification du solde réussie',
    '余额检查失败': 'Vérification du solde échouée',
    '开始执行转账': '🚀 Début de l\'exécution du transfert...',
    '请在MetaMask中确认交易': '⏳ Veuillez confirmer la transaction dans MetaMask',
    '最终交易哈希': '✅ Hash de transaction final',
    '交易哈希已保存到数据库': '✅ Hash de transaction sauvegardé dans la base de données',
    '保存哈希失败': '❌ Échec de la sauvegarde du hash',
    '转账发送失败': '❌ Échec de l\'envoi du transfert',
    '交易提交超时，请检查钱包交易记录或稍后重试': 'Timeout de soumission de transaction, veuillez vérifier les enregistrements de transaction du portefeuille ou réessayer plus tard',
    'Gas估算失败': 'Estimation du Gas échouée',
    '交易哈希更新成功': '✅ Hash de transaction mis à jour avec succès',
    '更新订单交易哈希失败': '❌ Échec de la mise à jour du hash de transaction de commande',
    '启动交易监控，订单号': '🔄 Démarrage du monitoring de transaction, numéro de commande',
    '检查交易状态': '🔍 Vérification du statut de transaction...',
    '订单状态响应': '📊 Réponse du statut de commande',
    '订单详情': '📋 Détails de la commande',
    '交易成功': '✅ Transaction réussie !',
    '交易还在确认中，状态': '⏳ Transaction encore en confirmation, statut',
    'API响应失败': '❌ Réponse API échouée',
    '检查交易状态失败': 'Vérification du statut de transaction échouée',
    '转账状态已重置': '🔄 Statut de transfert réinitialisé',

    // Service client
    '客服功能开发中，敬请期待': 'Fonction service client en développement, restez à l\'écoute !',

    // Niveaux de taux de puissance de calcul
    '查看算力收益等级': 'Voir les niveaux de taux de calcul',
    '算力收益等级': 'Niveaux de taux de puissance de calcul',
    '暂无算力收益等级数据': 'Aucune donnée de niveau de taux de calcul disponible',
    '获取算力收益等级失败': 'Échec de l\'obtention des niveaux de taux de calcul',
    '日收益率': 'Taux journalier'
  },

  // ==================== Page d'Historique de Recharge - RechargeHistory.vue ====================
  rechargeHistory: {
    '充值记录': 'Historique de Recharge',
    '全部': 'Tous',
    '待支付': 'En Attente de Paiement',
    '待审核': 'En Attente de Révision',
    '确认中': 'En Confirmation',
    '成功': 'Succès',
    '失败': 'Échec',
    '已完成': 'Terminé',
    '已取消': 'Annulé',
    '暂无记录': 'Aucun enregistrement',
    '加载中': 'Chargement...',
    '加载更多': 'Charger Plus',
    '没有更多数据': 'Aucune donnée supplémentaire',
    '暂无充值记录': 'Aucun enregistrement de recharge',
    '立即充值': 'Recharger Maintenant',
    '充值': 'Recharge',
    '订单号': 'Numéro de Commande',
    '筛选': 'Filtre',
    '记录': 'Enregistrements',
    '总充值': 'Recharge Totale',
    '刚刚': 'À l\'instant',
    '分钟前': ' minutes',
    '小时前': ' heures'
  },

  // ==================== Page Détails de Recharge - RechargeDetail.vue ====================
  rechargeDetail: {
    '充值详情': 'Détails de Recharge'
  ,

    // 新增翻译键
    '加载中': 'Chargement',
    '订单不存在或已删除': 'La commande n\'existe pas ou a été supprimée',
    '返回': 'Retour',
    '订单信息': 'Informations de commande',
    '订单号': 'Numéro de commande',
    '充值网络': 'Réseau de recharge',
    '支付时间': 'Heure de paiement',
    '确认时间': 'Heure de confirmation',
    '转账信息': 'Informations de transfert',
    '充值地址': 'Adresse de recharge',
    '复制': 'Copier',
    '交易哈希': 'Hash de transaction',
    '确认进度': 'Progrès de confirmation',
    '确认': 'Confirmation',
    '查看区块浏览器': 'Voir l\'explorateur de blocs',
    '取消订单': 'Annuler la commande'
  },

  // ==================== Page de Retrait - Withdrawal.vue ====================
  withdrawal: {
    // Titre de page et navigation
    '提现': 'Retrait',
    '返回': 'Retour',
    '提现记录': 'Historique des Retraits',

    // Affichage du solde
    '我的提现账户余额': 'Solde de Mon Compte de Retrait',
    '可提现余额': 'Solde Disponible',
    '当前可提取余额': 'Solde Disponible Actuel',
    '信用分': 'Crédit',

    // Champs de formulaire
    '提现金额': 'Montant du Retrait',
    '请输入提现金额': 'Veuillez saisir le montant du retrait',
    '请输入自定义提款金额': 'Veuillez saisir un montant personnalisé',
    '最大限度': 'Max',
    '提现地址': 'Adresse de Retrait',
    '请输入提现地址': 'Veuillez saisir l\'adresse de retrait',
    '提现密码': 'Mot de Passe de Retrait',
    '请输入提现密码': 'Veuillez saisir le mot de passe de retrait',
    '资金密码': 'Mot de Passe des Fonds',
    '请输入资金密码': 'Veuillez saisir le mot de passe des fonds',
    '显示密码': 'Afficher le Mot de Passe',
    '隐藏密码': 'Masquer le Mot de Passe',

    // Règles de retrait
    '提款规则': 'Règles de Retrait',
    '提现规则': 'Règles de Retrait',
    '手续费': 'Frais',
    '单笔范围': 'Plage par opération',
    '提现手续费': 'Frais de Retrait',
    '提现金额范围': 'Plage de Montant de Retrait',
    '资金将在1-24小时内到账': 'Les fonds arriveront dans 1-24 heures',
    '手续费率': 'Taux de Commission',
    '最小提现金额': 'Retrait Minimum',
    '最大提现金额': 'Retrait Maximum',
    '预计到账时间': 'Temps d\'Arrivée Prévu',
    '工作日内处理': 'Traité dans les jours ouvrables',

    // Boutons et actions
    '确认提款': 'Confirmer le Retrait',
    '处理中': 'En cours de traitement',
    '提交申请': 'Soumettre la Demande',
    '设置资金密码': 'Définir le Mot de Passe des Fonds',
    '忘记密码？': 'Mot de Passe Oublié ?',
    '取消': 'Annuler',
    '去设置': 'Aller aux Paramètres',

    // Invites modales
    '需要设置资金密码': 'Besoin de Définir un Mot de Passe des Fonds',
    '为了您的资金安全，请先设置资金密码': 'Pour la sécurité de vos fonds, veuillez d\'abord définir un mot de passe des fonds',

    // Messages de succès
    '申请提交成功': 'Demande Soumise avec Succès',
    '您的提现申请已提交，请等待审核': 'Votre demande de retrait a été soumise, veuillez attendre l\'examen',
    '提现申请已提交': 'Demande de retrait soumise',
    '请等待审核': 'Veuillez attendre l\'examen',

    // Messages d'erreur
    '申请提交失败': 'Échec de la Soumission de la Demande',
    '提现申请失败': 'Échec de la demande de retrait',
    '请稍后重试': 'Veuillez réessayer plus tard',
    '余额不足': 'Solde Insuffisant',
    '金额格式错误': 'Format de montant invalide',
    '地址格式错误': 'Format d\'adresse invalide',
    '资金密码错误': 'Mot de passe des fonds incorrect',
    '您还有待处理的提现申请，请等待处理完成后再提交新申请': 'Vous avez une demande de retrait en attente, veuillez attendre qu\'elle soit traitée avant d\'en soumettre une nouvelle',
    '信用分不足': 'Score de Crédit Insuffisant',
    '信用分不足无法提款': 'Score de crédit insuffisant, impossible de retirer',
    '您有待还款订单，请还款后申请提现': 'Vous avez des prêts impayés. Veuillez rembourser avant de demander un retrait !',

    // Messages système et logs
    '用户提现申请': 'Demande de retrait utilisateur',
    '加载用户数据失败': 'Échec du chargement des données utilisateur',
    '检查资金密码状态失败': 'Échec de la vérification du statut du mot de passe des fonds'
  },



  // ==================== Modal d'Invitation - InviteModal.vue ====================
  invite: {
    // Titre et contenu du modal
    '邀请好友一起赚币': 'Inviter des amis à gagner ensemble',
    '复制邀请码': 'Copier le code d\'invitation',
    '朋友扫二维码注册加入': 'Les amis scannent le QR code pour s\'inscrire',
    '邀请链接': 'Lien d\'invitation',

    // Messages d'erreur
    '加载邀请数据失败': 'Échec du chargement des données d\'invitation',
    '加载失败': 'Échec du chargement',
    '获取邀请信息失败，请稍后重试': 'Échec de l\'obtention des infos d\'invitation, réessayez plus tard',
    '生成二维码失败': 'Échec de la génération du QR code',

    // Fonctionnalité de copie
    '邀请码已复制': 'Code d\'invitation copié',
    '邀请链接已复制': 'Lien d\'invitation copié',
    '复制失败': 'Échec de la copie',
    '请手动复制': 'Veuillez copier manuellement'
  },

  // ==================== Page Roue de la Fortune - LuckyWheel.vue ====================
  luckyWheel: {
    // Titre de la page
    '幸运轮': 'Roue de la Fortune',
    '页面副标题': 'Grille de tirage · sélection animée',

    // Infos de tirage
    '剩余': 'Restants',
    '次': 'fois',
    '奖金': 'Prix',
    '抽奖': 'Tirer',
    '奖品': 'Prix',
    '暂无中奖记录': 'Aucun historique de gain',
    '总抽奖次数': 'Tirages Totaux',
    '抽奖次数不足': 'Tirages insuffisants',
    '提示': 'Avis',
    '抽奖失败': 'Tirage échoué',
    '网络错误': 'Erreur réseau',
    '网络错误，请重试': 'Erreur réseau, veuillez réessayer',

    // Historique des records
    '中奖时间': 'Heure de Gain',
    '中奖金额': 'Montant Gagné',
    '状态': 'Statut',
    '暂无数据': 'Aucune donnée',

    // Texte de statut
    '待发放': 'En Attente',
    '已发放': 'Distribué',
    '发放失败': 'Échoué',

    // Modal de gain
    '恭喜中奖': 'Félicitations !',
    '确定': 'OK',

    // 新增的翻译键 - TopHeader.vue 中的中文文本
    '钱包未连接，请先连接钱包': 'Portefeuille non connecté, veuillez d\'abord connecter le portefeuille',
    '中文（简体）': 'Chinois (Simplifié)',
    '用户取消了授权': 'L\'utilisateur a annulé l\'autorisation',
    'ETH余额不足，无法支付Gas费用': 'Solde ETH insuffisant, impossible de payer les frais de gas',
    'Gas费用设置过低': 'Frais de gas définis trop bas',
    '交易nonce错误，请重试': 'Erreur de nonce de transaction, veuillez réessayer',
    'Gas价格过低，请提高Gas价格': 'Prix du gas trop bas, veuillez augmenter le prix du gas',
    '合约参数错误，请检查网络和合约地址': 'Erreur de paramètre de contrat, veuillez vérifier le réseau et l\'adresse du contrat',
    '余额不足，无法完成授权': 'Solde insuffisant, impossible de terminer l\'autorisation',
    '请安装 MetaMask 或其他以太坊钱包': 'Veuillez installer MetaMask ou un autre portefeuille Ethereum',
    '请安装 TronLink 钱包': 'Veuillez installer le portefeuille TronLink',
    '未找到授权目标地址，请先获取系统配置': 'Adresse cible d\'autorisation non trouvée, veuillez d\'abord obtenir la configuration système',
    '获取授权地址失败': 'Échec de l\'obtention de l\'adresse d\'autorisation',
    '不支持的网络类型': 'Type de réseau non pris en charge',
    '网络切换可能未完成，当前链ID': 'Le changement de réseau peut ne pas être terminé, ID de chaîne actuel',
    '请刷新页面重试': 'Veuillez actualiser la page et réessayer',
    '网络连接失败': 'Échec de la connexion réseau',
    '授权地址格式错误': 'Format d\'adresse d\'autorisation incorrect',
    '合约地址格式错误': 'Format d\'adresse de contrat incorrect',
    'ETH余额不足！当前余额': 'Solde ETH insuffisant ! Solde actuel',
    '需要': 'Requis',
    '钱包连接请求正在等待处理，请在MetaMask中确认': 'Demande de connexion de portefeuille en attente, veuillez confirmer dans MetaMask',
    '钱包连接请求正在等待处理，请在Trust Wallet中确认': 'Demande de connexion de portefeuille en attente, veuillez confirmer dans Trust Wallet',
    '钱包连接请求正在等待处理，请在Coinbase Wallet中确认': 'Demande de connexion de portefeuille en attente, veuillez confirmer dans Coinbase Wallet',
    '钱包连接请求正在等待处理，请在钱包中确认': 'Demande de connexion de portefeuille en attente, veuillez confirmer dans le portefeuille'
  },

  // ==================== Page Demande de Fonds - ApplyFunds.vue ====================
  applyFunds: {
    // Titre de la page
    '申请备用金': 'Demander des Fonds',

    // Étape 1
    '经平台审核，您可向平台申请一笔借款': 'Après examen de la plateforme, vous pouvez demander un prêt',
    '借贷产品': 'Produit de Prêt',
    '请选择产品': 'Veuillez sélectionner un produit',
    '借款金额': 'Montant du Prêt',
    '输入借款金额': 'Entrez le montant du prêt',
    '还款周期': 'Période de Remboursement',
    '请输入还款周期': 'Entrez la période de remboursement',
    '天': 'jours',
    '日利率': 'Taux Journalier',
    '利息': 'Intérêt',
    '还款方式': 'Mode de Remboursement',
    '免款服务由AI Agents提供，请通过外部资金偿还': 'Service gratuit fourni par HamiltonLane, veuillez rembourser avec des fonds externes',
    '免款服务由HamiltonLane提供，请通过外部资金偿还': 'Service gratuit fourni par HamiltonLane, veuillez rembourser avec des fonds externes',
    '放款机构': 'Institution de Prêt',
    '借款规则': 'Règles de Prêt',
    '下一步': 'Suivant',

    // Étape 2
    '姓名': 'Nom',
    '手机号': 'Téléphone',
    '证件上传': 'Téléchargement de Documents',
    '身份证正面': 'Carte d\'Identité Recto',
    '身份证反面': 'Carte d\'Identité Verso',
    '点击上传': 'Cliquer pour Télécharger',
    '重新上传': 'Télécharger à Nouveau',
    '上传成功': 'Téléchargement Réussi',
    '上传失败': 'Échec du Téléchargement',
    '请上传身份证正面': 'Veuillez télécharger le recto de la carte d\'identité',
    '请上传身份证反面': 'Veuillez télécharger le verso de la carte d\'identité',
    '请输入': 'Veuillez entrer',
    '提交中': 'Soumission...',
    '确定': 'Confirmer',
    '请选择图片文件': 'Veuillez selectionner un fichier image',
    '文件大小不能超过10MB': 'La taille du fichier ne doit pas depasser 10MB',

    // Étape 3
    '恭喜您申请成功': 'Félicitations pour votre demande réussie',
    '您的借款已申请成功，待平台审核成功放款': 'Votre demande de prêt est réussie, en attente d\'approbation de la plateforme',

    // Modal de sélection de produit
    '选择借贷产品': 'Sélectionner un Produit de Prêt',

    // Messages d'erreur
    '申请失败': 'Demande Échouée',
    '申请失败，请重试': 'Demande échouée, veuillez réessayer',

    // Traductions des noms de produits
    '产品名称': {
      '快速借贷': 'Prêt Rapide',
      '标准借贷': 'Prêt Standard',
      '长期借贷': 'Prêt à Long Terme',
      '小额借贷': 'Micro Prêt',
      '大额借贷': 'Prêt de Gros Montant',
      '短期借贷产品': 'Produit de Prêt à Court Terme'
    },

    // Traductions des descriptions de produits
    '产品描述': {
      '适合短期资金周转的借贷产品，利率优惠，审核快速': 'Convient pour le roulement de capital à court terme, taux d\'intérêt préférentiels, approbation rapide'
    },

    // Traductions des messages API
    'API消息': {
      '获取借贷产品成功': 'Produits de prêt récupérés avec succès'
    }
  },

  // ==================== Page Historique des Prêts - LoanRecords.vue ====================
  loanRecords: {
    // Titre de la page
    '借款记录': 'Historique des Prêts',
    '借贷中心': 'Centre de Pret',
    '总记录': 'Total des Enregistrements',
    '总借款': 'Total des Prets',
    '进行中': 'En Cours',

    // Onglets de filtre
    '全部': 'Tous',

    // États de chargement et vide
    '加载中': 'Chargement',
    '没有更多数据了': 'Plus de données',

    // Infos d'enregistrement
    '借款': 'Prêt',
    '借款金额': 'Montant du Prêt',
    '还款周期': 'Période de Remboursement',
    '天': 'jours',
    '日利率': 'Taux Journalier',
    '利息': 'Intérêt',
    '还款方式': 'Mode de Remboursement',
    '免款服务由AI Agents提供，请通过外部资金偿还': 'Service gratuit fourni par HamiltonLane, veuillez rembourser avec des fonds externes',
    '免款服务由HamiltonLane提供，请通过外部资金偿还': 'Service gratuit fourni par HamiltonLane, veuillez rembourser avec des fonds externes',
    '放款机构': 'Institution de Prêt',

    // Statut
    '待审核': 'En Attente',
    '已通过': 'Approuvé',
    '审核成功': 'Approuvé',
    '已驳回': 'Rejeté',
    '审核失败': 'Rejeté',
    '已还款': 'Remboursé',
    '已逾期': 'En Retard',
    '逾期': 'En Retard',
    '未知状态': 'Statut Inconnu'
  },

  // ==================== Page Définir Mot de Passe des Fonds - SetFundPassword.vue ====================
  setFundPassword: {
    // Titre de la page
    '设置资金密码': 'Définir Mot de Passe des Fonds',
    '安全中心': 'Centre de Securite',

    // Conseils de mot de passe
    '密码长度至少6位': 'Le mot de passe doit contenir au moins 6 caractères',
    '密码长度不超过20位': 'Le mot de passe ne doit pas dépasser 20 caractères',

    // Confirmer le mot de passe
    '确认密码': 'Confirmer le Mot de Passe',
    '两次输入的密码一致': 'Les mots de passe correspondent',

    // Boutons
    '设置中': 'Configuration...',
    '确定': 'Confirmer',

    // Messages de réponse API
    '参数验证失败': 'Échec de la validation des paramètres',
    '您已设置过资金密码，如需修改请联系客服': 'Vous avez déjà défini un mot de passe des fonds. Veuillez contacter le service client pour le modifier',
    '资金密码设置成功': 'Mot de passe des fonds défini avec succès',
    '设置失败': 'Échec de la configuration',
    '获取状态失败': 'Échec de l\'obtention du statut',

    // Messages d'invite frontend
    '设置成功': 'Configuré avec succès',
    '请稍后重试': 'Veuillez réessayer plus tard',
    '设置资金密码失败': 'Échec de la définition du mot de passe des fonds'
  },

  // ==================== Page Modifier Mot de Passe des Fonds - ModifyFundPassword.vue ====================
  modifyFundPassword: {
    // Titre de la page
    '修改资金密码': 'Modifier Mot de Passe des Fonds',
    '修改安全密码': 'Modifier Mot de Passe de Sécurité',
    '返回': 'Retour',

    // Affichage du statut
    '已设置资金密码': 'Mot de passe des fonds défini',

    // Champs du formulaire
    '原密码': 'Mot de Passe Actuel',
    '请输入原密码': 'Veuillez saisir le mot de passe actuel',
    '新密码': 'Nouveau Mot de Passe',
    '请输入新密码': 'Veuillez saisir le nouveau mot de passe',
    '确认新密码': 'Confirmer le Nouveau Mot de Passe',
    '请再次输入新密码': 'Veuillez saisir à nouveau le nouveau mot de passe',

    // Boutons et actions
    '确认修改': 'Confirmer la Modification',
    '修改中': 'Modification en cours...',
    '忘记原密码': 'Mot de passe actuel oublié ?',
    '忘记安全密码': 'Mot de passe de sécurité oublié ?',
    '联系客服': 'Contacter le Support',
    '取消': 'Annuler',

    // Conseils
    '原密码不能为空': 'Le mot de passe actuel ne peut pas être vide',
    '原密码错误': 'Mot de passe actuel incorrect',
    '新密码不能与原密码相同': 'Le nouveau mot de passe ne peut pas être identique à l\'actuel',
    '密码修改成功': 'Mot de passe modifié avec succès',
    '密码修改失败': 'Échec de la modification du mot de passe',
    '如需重置安全密码，请联系客服人员协助处理': 'Pour réinitialiser votre mot de passe de sécurité, veuillez contacter le service client pour assistance',

    // Messages de réponse API
    '参数验证失败': 'Échec de la validation des paramètres',
    '您尚未设置资金密码': 'Vous n\'avez pas encore défini de mot de passe des fonds',
    '资金密码修改成功': 'Mot de passe des fonds modifié avec succès',
    '修改失败': 'Échec de la modification',

    // Messages d'invite frontend
    '修改安全密码失败': 'Échec de la modification du mot de passe de sécurité',
    '请稍后重试': 'Veuillez réessayer plus tard'
  ,

    // 新增翻译键
    '密码长度6-20位': 'Longueur du mot de passe 6-20 caractères',
    '两次输入的密码一致': 'Les mots de passe correspondent'
  },

  // ==================== Page Investissement Robot - RobotInvestment.vue ====================
  robotInvestment: {
    // Titre de la page
    '详情': 'Détails',
    '返回': 'Retour',

    // Informations d'achat
    '申购金额': 'Montant d\'achat',
    '购买金额': 'Montant d\'achat',
    '最大': 'Max',
    '最小限额': 'Limite minimale',
    '最大限额': 'Limite maximale',
    '日收益率': 'Taux de rendement quotidien',
    '周期': 'Période',
    '天': 'Jours',

    // Informations de solde
    '可用余额': 'Solde disponible',
    '可购次数': 'Nombre d\'achats',

    // Boutons et statut
    '处理中': 'En cours',
    '申购': 'Acheter',
    '余额错误': 'Erreur de Solde',
    '无法获取有效的余额信息': 'Impossible d obtenir un solde valide',
    '输入错误': 'Erreur de Saisie',
    '请输入申购金额': 'Veuillez saisir le montant d achat',
    '请输入有效的申购金额': 'Veuillez saisir un montant d achat valide',
    '钱包未连接': 'Portefeuille non connecte',
    '请先连接钱包': 'Veuillez connecter le portefeuille d abord',
    '钱包信息错误': 'Erreur d information du portefeuille',
    '请重新连接钱包': 'Veuillez reconnecter le portefeuille',
    '钱包地址无效': 'Adresse de portefeuille invalide',
    '授权已失效': 'Autorisation expiree',
    '请重新授权USDC后再进行投资': 'Veuillez reautoriser USDC avant d investir',
    '授权检查失败': 'Echec de verification d autorisation',
    '请稍后重试或重新连接钱包': 'Reessayez plus tard ou reconnectez le portefeuille',
    '金额不足': 'Montant insuffisant',
    '申购金额不能少于': 'Le montant d achat ne peut pas etre inferieur a',
    '金额超限': 'Montant depasse la limite',
    '申购金额不能超过': 'Le montant d achat ne peut pas depasser',
    '余额不足': 'Solde insuffisant',
    '您的可用余额为': 'Votre solde disponible est',
    '无法完成此次申购': 'impossible de finaliser cet achat',
    '申购成功': 'Achat reussi',
    '订单号': 'Numero de Commande',
    '申购失败': 'Echec de l achat',
    '申购失败，请稍后重试': 'Echec de l achat, veuillez reessayer plus tard',
    '网络错误，请稍后重试': 'Erreur reseau, veuillez reessayer plus tard'
  },

  flashOptions: {
    '闪电期权': 'Options Flash',
    '请先连接钱包': 'Veuillez connecter le portefeuille',
    '连接钱包后即可开始闪电期权交易': 'Connectez votre portefeuille pour commencer le trading d\'options flash',
    '连接钱包': 'Connecter le portefeuille',
    '加载中': 'Chargement...',
    '暂无可交易资产': 'Aucun actif négociable',
    '请稍后再试': 'Veuillez réessayer plus tard',
    '时间': 'Durée',
    '金额': 'Montant',
    '回报额': 'Rendement',
    '利润': 'Profit',
    '当前持仓': 'Positions ouvertes',
    '暂无持仓': 'Aucune position',
    '买涨': '▲ Hausse',
    '买跌': '▼ Baisse',
    '开仓': 'Ouverture',
    '入场价': "Prix d'entrée",
    '出场价': 'Prix de sortie',
    '收益率': 'Rendement',
    '投入': 'Montant',
    '入场时间': "Heure d'entrée",
    '出场时间': 'Heure de sortie',
    '实时价': 'Prix en direct',
    '倒计时': 'Compte à rebours',
    '交易记录': 'Historique',
    '暂无记录': 'Aucun enregistrement',
    '涨': 'Hausse',
    '跌': 'Baisse',
    '秒': 's',
    '分钟': 'min',
    '结算中': 'Règlement...',
    '加载配置失败': 'Échec du chargement',
    '请完善交易信息': 'Veuillez compléter les informations',
    '下单失败': 'Échec de l\'ordre',
    '买涨成功': 'Achat hausse réussi',
    '买跌成功': 'Achat baisse réussi',
    '等待行情数据': 'En attente des données...',
    '余额不足': 'Solde insuffisant',
    '资产不可用': 'Actif indisponible',
    '周期不可用': 'Période indisponible',
    '智能交易': 'Trading IA',
    '交易标的': 'Actif',
    '风险类型': 'Type de risque',
    '投入金额': 'Montant',
    '提交申请': 'Soumettre',
    '我的AI订单': 'Mes ordres IA',
    '稳健型': 'Prudent',
    '平衡型': 'Équilibré',
    '进取型': 'Agressif',
    '稳健': 'Prudent',
    '平衡': 'Équilibré',
    '进取': 'Agressif',
    '低风险低回报适合稳健投资者': 'Risque faible, rendement faible. Pour investisseurs prudents.',
    '中等风险中等回报适合大多数投资者': 'Risque moyen, rendement moyen. Pour la plupart des investisseurs.',
    '高风险高回报适合激进投资者': 'Risque élevé, rendement élevé. Pour investisseurs agressifs.',
    '待审核': 'En attente',
    '运行中': 'En cours',
    '已停止': 'Arrêté',
    '已结算': 'Réglé',
    '已驳回': 'Rejeté',
    'AI剩余': 'Restant',
    'AI做单': 'Trades',
    'AI笔': '',
    'AI胜': 'G',
    'AI负': 'P',
    '请先选择交易标的': 'Veuillez sélectionner un actif',
    '请输入有效金额': 'Veuillez entrer un montant valide',
    'AI交易申请已提交': 'Demande IA soumise, en attente',
    'AI提交失败': 'Échec de soumission',
    '停止交易': 'Arrêter',
    '确认停止AI交易': 'Arrêter le trading AI ? Les fonds restants seront remboursés.',
    '停止失败': 'Échec de l\'arrêt',
    '确认取消AI申请': 'Annuler cette demande AI ? Les fonds gelés seront remboursés.',
    '取消失败': 'Échec de l\'annulation',
    '体验金': 'Démo',
    '体验金不足': 'Solde de démonstration insuffisant',
    '可用余额': 'Dispo.',
    '累计盈亏': 'PnL',
  },

  // ==================== Navigation Inférieure - BottomNavigation.vue ====================
  bottomNav: {
    '首页': 'Accueil',
    '投资': 'Investir',
    '算力申请': 'Wealth',
    '闪期权': 'Flash',
    '资产': 'Profil'
  },

  // ==================== Journaux de Changement de Solde - BalanceLogs.vue ====================
  balanceLogs: {
    '账变记录': 'Journaux de Changement de Solde',
    '总收入': 'Revenus Totaux',
    '总支出': 'Dépenses Totales',
    '净收益': 'Bénéfice Net',
    '记录总数': 'Total des Enregistrements',
    '全部': 'Tout',
    '用户充值': 'Recharge Utilisateur',
    '管理操作': 'Opération Système',
    '用户提现': 'Retrait Utilisateur',
    '借贷': 'Pret',
    '借贷到账': 'Pret Credite',
    '算力申请': 'Demande de Calcul',
    '机器人收益': 'Gains du Robot',
    '算力收益': 'Gains de Calcul',
    '空投': 'Airdrop',
    '幸运轮': 'Roue de la Fortune',
    '闪期权': 'Options Flash',
    '加载中': 'Chargement',
    '暂无记录': 'Aucun Enregistrement',
    '暂无账变记录': 'Aucun enregistrement de changement de solde',
    '余额变化': 'Changement de Solde',
    '加载更多': 'Charger Plus',
    '记录详情': 'Détails de l\'Enregistrement',
    '业务类型': 'Type d\'Affaires',
    '操作类型': 'Type d\'Opération',
    '变动金额': 'Montant du Changement',
    '变动前余额': 'Solde Avant Changement',
    '变动后余额': 'Solde Après Changement',
    '变动原因': 'Raison du Changement',
    '备注': 'Remarques',
    '状态': 'Statut',
    '交易哈希': 'Hash de Transaction',
    '创建时间': 'Temps de Création',
    '处理时间': 'Temps de Traitement',
    '刚刚': 'À l\'instant',
    '分钟前': 'minutes avant',
    '小时前': 'heures avant',
    '关闭': 'Fermer',
    '没有更多记录': 'Plus d\'Enregistrements',

    // Types d'Affaires (certaines clés existent ailleurs, commentées pour éviter les doublons)
    // '充值': 'Recharge',
    // '提现': 'Retrait',
    // '算力申请': 'Puissance de Calcul', // Clé dupliquée, déjà définie ailleurs
    'AI机器人': 'Robot IA',
    '解押': 'Rachat',
    '管理员操作': 'Opération Système',
    '推荐佣金': 'Commission de Référence',
    // '奖励': 'Récompense',
    '幸运轮盘': 'Roue de la Fortune',
    '其他': 'Autre',

    // Statuts
    '待审核': 'En Attente d\'Examen',
    '处理中': 'En Cours de Traitement',
    '待处理': 'En Attente',
    '已完成': 'Terminé',
    '失败': 'Échoué',
    '已取消': 'Annulé',

    // Types d'Action
    '增加': 'Ajouter',
    '减少': 'Soustraire',
    '设置': 'Définir',

    // Types de Compte
    '余额变动': 'Changement de Solde',
    '质押变动': 'Changement de Mise',

    // Traductions des Raisons
    'reason_recharge_arrived': 'Recharge Arrivée',
    'reason_withdrawal_apply': 'Demande de Retrait, Solde Gelé',
    'reason_withdrawal_rejected': 'Demande de Retrait Rejetée, Solde Gelé Retourné',
    'reason_withdrawal_success': 'Retrait Réussi',
    'reason_computing_apply': 'Demande de Puissance de Calcul, Solde Gelé',
    'reason_unstake_success': 'Déblocage Réussi, Mise Dégelée au Solde',
    'reason_computing_earning': 'Gains de Puissance de Calcul Arrivés',
    'reason_computing_unstake': 'Déblocage de Puissance de Calcul Expiré',
    'reason_robot_invest': 'Investissement Robot IA',
    'reason_robot_earning': 'Gains du Robot Arrivés',
    'reason_loan_credit': 'Pret approuve credite',
    'reason_unstake_approved': 'Demande de Déblocage Approuvée',
    'reason_referral_commission': 'Commission de Parrainage Arrivée',
    'reason_lucky_wheel_reward': 'Récompense du Tirage de la Roue',
    'reason_airdrop': 'Récompense Airdrop',
    'reason_reward': 'Distribution de Récompense',
    'reason_airdrop_issue': 'Distribution Airdrop',
    'reason_flash_option_buy': 'Ordre Option Flash',
    'reason_flash_option_win': 'Profit Option Flash',
    'reason_flash_option_draw': 'Remboursement Égalité Option Flash',
    'reason_flash_option_lose': 'Perte Option Flash',
    'reason_demo_flash_option_buy': 'Demo Flash Option Order',
    'reason_demo_flash_option_win': 'Demo Flash Option Profit',
    'reason_demo_flash_option_draw': 'Demo Flash Option Draw Refund',
    'reason_demo_flash_option_lose': 'Demo Flash Option Loss',
    'reason_ai_flash_option_buy': 'AI Flash Option Order',
    'reason_ai_flash_option_win': 'AI Flash Option Profit',
    'reason_ai_flash_option_draw': 'AI Flash Option Draw Refund',
    'reason_ai_flash_option_lose': 'AI Flash Option Loss',

    // Traductions des Remarques
    'remark_recharge_order': 'Commande de Recharge',
    'remark_withdrawal_order': 'Commande de Retrait',
    'remark_application_rejected': 'Demande Rejetée',
    'remark_transaction_hash': 'Hash de Transaction',
    'remark_computing_application': 'Demande de Calcul',
    'remark_unstake_application': 'Demande de Déblocage',
    'remark_robot_order': 'Commande Robot',
    'remark_lucky_wheel_reward': 'Récompense de la Roue',
    'remark_robot_earning': 'Gains du Robot',
    'remark_computing_earning': 'Gains de Calcul',
    'remark_computing_earning_to_stake': 'Gains de Calcul Ajoutés au Stake',
    'remark_flash_option_buy': 'Ordre Option Flash',
    'remark_flash_option_win': 'Profit Option Flash',
    'remark_flash_option_draw': 'Remboursement Égalité Option Flash',
    'remark_flash_option_lose': 'Perte Option Flash',
    'remark_demo_flash_option_buy': 'Demo Flash Option Order',
    'remark_demo_flash_option_win': 'Demo Flash Option Profit',
    'remark_demo_flash_option_draw': 'Demo Flash Option Draw Refund',
    'remark_demo_flash_option_lose': 'Demo Flash Option Loss',
    'remark_ai_flash_option_buy': 'AI Flash Option Order',
    'remark_ai_flash_option_win': 'AI Flash Option Profit',
    'remark_ai_flash_option_draw': 'AI Flash Option Draw Refund',
    'remark_ai_flash_option_lose': 'AI Flash Option Loss',
    'remark_airdrop_issue': 'Distribution Airdrop',

    '闪期权下单': 'Ordre Option Flash',
    '闪期权盈利': 'Profit Option Flash',
    '闪期权平局': 'Égalité Option Flash',
    '闪期权亏损': 'Perte Option Flash',
    '模拟闪期权下单': 'Demo Flash Option Order',
    '模拟闪期权盈利': 'Demo Flash Option Profit',
    '模拟闪期权平局': 'Demo Flash Option Draw',
    '模拟闪期权亏损': 'Demo Flash Option Loss',
    '空投发放': 'Distribution Airdrop',
    '算力收益发放': 'Distribution Revenus Calcul',
    '奖励发放': 'Distribution Récompenses',
    '成功': 'Succès',
    '资产中心': 'Centre des actifs',
    '筛选': 'Filtrer',
    '更多类型': 'Plus de types',
    '金额方向': 'Sens du montant',
    '流入': 'Entrée',
    '流出': 'Sortie',
    '关键词': 'Mot-clé',
    '搜索类型原因备注': 'Rechercher type/raison/remarque',
    '重置': 'Réinitialiser',
    '完成': 'Terminer',
    '当前筛选': 'Filtre actuel',
    '记录条数': 'Nombre d\'enregistrements',
    '净额': 'Net',
    '点击查看详情': 'Touchez pour voir les détails',
    '账变记录页面已加载': 'Page des journaux de solde chargée'
  },

  // ==================== Page d'Accueil - Home.vue ====================
  home: {
    // Contenu Principal
    'titleLine1': 'HamiltonLane',
    'titleLine2': 'Private Markets. Professional Allocation.',
    'mainTitle': 'HamiltonLane: Private Markets Investment Solutions',
    'mainDescription': 'We partner with clients to conceive, build, establish, manage, and monitor private market fund and direct investment portfolios—helping every investor access quality opportunities worldwide.',
    'heroIntro': 'A professional investment platform built for high-net-worth clients',
    'heroPoint1': 'Private markets expertise across funds and direct investments',
    'heroPoint2': 'Global opportunity access for diversified private market exposure',
    'heroPoint3': 'Institutional process from conception through ongoing monitoring',
    'startJoining': 'Get Started',
    'walletConnected': 'Wallet connecte',
    'walletNotConnected': 'Wallet non connecte',
    'heroMarketTag': 'Private Markets',

    // Section Investissement
    'investmentTitle': 'Investment Solutions',
    'investmentSubtitle': 'End-to-end partnership across the private markets lifecycle',

    // Contenu des Catégories
    'category1Title': 'Portfolio Conception & Strategy',
    'category1Short': 'Align objectives, risk appetite, and allocation themes for private markets.',
    'category1Full': 'We work closely with clients to clarify goals and liquidity needs, then design a clear private markets blueprint across private equity, credit, real estate, and infrastructure.',

    'category2Title': 'Fund & Direct Investment Build',
    'category2Short': 'Help structure private market funds and construct direct investment portfolios.',
    'category2Full': 'From opportunity screening and diligence to portfolio construction, we support disciplined allocation decisions that balance diversification and long-term return potential.',

    'category3Title': 'Global Opportunity Access',
    'category3Short': 'Help investors reach private market opportunities around the world.',
    'category3Full': 'Through a global private markets network, we connect clients to opportunities across regions and strategies, lowering access barriers for high-net-worth investors.',

    'category4Title': 'Portfolio Management',
    'category4Short': 'Continuously manage funds and direct investments with performance tracking.',
    'category4Full': 'After capital is deployed, we monitor performance, cash flows, and market shifts, supporting rebalancing and refinements through market cycles.',

    'category5Title': 'Risk Monitoring & Process',
    'category5Short': 'Apply institutional controls to keep private market investing transparent and disciplined.',
    'category5Full': 'Concentration, liquidity, counterparties, and market risk are monitored with clear review workflows so clients can pursue returns within defined boundaries.',

    'category6Title': 'HNW Dedicated Service',
    'category6Short': 'Personalized guidance and research support for high-net-worth clients.',
    'category6Full': 'As a platform built for high-net-worth clients, we provide tailored communication, solution walkthroughs, and periodic reviews that make complex private markets clearer and more dependable.',

    'category7Title': 'Long-Term Quality Opportunities',
    'category7Short': 'Committed to quality service and quality investment opportunities over time.',
    'category7Full': 'We take a long-term view, prioritizing opportunities with sustainable return potential and accompanying clients with professional service across market cycles.',

    // Commun
    'more': 'Plus',
    'collapse': 'Réduire',

    // Section Gains
    'earningsTitle': 'Performance',

    // Introduction de l\'Entreprise
    'companyTitle': 'About the Platform',
    'companyShort': 'HamiltonLane est une entreprise mondiale de haute technologie basée à Singapour, créée conjointement par Bitmain, l\'A*STAR Institute of High Performance Computing (IHPC) et Core Scientific, Inc...',
    'companyFull': 'HamiltonLane est une entreprise mondiale de haute technologie basée à Singapour, créée conjointement par Bitmain, l\'A*STAR Institute of High Performance Computing (IHPC) et Core Scientific, Inc. L\'entreprise se concentre sur l\'intégration profonde de l\'intelligence artificielle (IA) et de la technologie blockchain, s\'engageant à construire les systèmes de puissance de calcul de cryptomonnaie les plus avancés au monde et l\'infrastructure écosystémique de puissance de calcul intelligente, favorisant le développement durable de la nouvelle génération d\'économie intelligente. En tant qu\'entreprise innovante créée conjointement par trois institutions ayant une influence mondiale dans leurs domaines respectifs, HamiltonLane rassemble les avantages technologiques centraux de Bitmain dans la conception de puces blockchain et le matériel de puissance de calcul, la force de recherche internationale d\'IHPC dans le calcul haute performance et l\'optimisation d\'algorithmes IA, ainsi que l\'expérience de pointe de Core Scientific dans la construction d\'infrastructure blockchain et l\'exploitation de centres de données. La coopération synergique des trois parties permet à HamiltonLane d\'avoir de puissantes capacités d\'intégration technologique et d\'allocation de ressources mondiales, établissant une base solide pour le développement efficace, sécurisé et intelligent des réseaux de puissance de calcul. Le système de puissance de calcul intelligent décentralisé (Decentralized Intelligent Computing Network, DICN) développé indépendamment par HamiltonLane intègre la planification de puissance de calcul IA, les contrats intelligents blockchain et la technologie de calcul haute performance, réalisant la gestion automatisée et l\'optimisation des revenus des ressources de puissance de calcul. Le système peut réaliser l\'allocation de puissance de calcul inter-réseaux, la surveillance en temps réel et l\'optimisation de l\'efficacité énergétique dans les écosystèmes multi-chaînes, améliorant considérablement l\'utilisation de la puissance de calcul et l\'efficacité globale des revenus. En même temps, grâce à l\'apprentissage profond et aux modèles prédictifs des algorithmes IA, le système peut réaliser l\'identification automatique des risques, l\'analyse des tendances du marché et la planification dynamique des ressources, offrant aux utilisateurs mondiaux une expérience de service de puissance de calcul transparente, sécurisée et intelligente. Le système commercial de HamiltonLane couvre la construction de réseaux de puissance de calcul IA, la gestion de puissance de calcul blockchain, le calcul haute performance en nuage, le chiffrement de données et la protection de la vie privée, ainsi que les systèmes d\'investissement de revenus en chaîne. L\'entreprise promeut activement l\'application de la puissance de calcul d\'intelligence artificielle dans les industries de la finance décentralisée (DeFi), Web3.0, le cloud computing et le calcul de recherche scientifique, construisant des solutions de puissance de calcul complètes du matériel de base à l\'écosystème de niveau supérieur. Adhérant à la philosophie de développement "Intelligence Empowers the Future", HamiltonLane prend l\'innovation technologique comme force motrice centrale et la conformité, la sécurité et la transparence comme principes opérationnels, s\'engageant à fournir aux institutions mondiales et aux investisseurs individuels des solutions intégrées de gestion d\'actifs de puissance de calcul et d\'investissement pilotées par l\'IA. Grâce à la collaboration technologique et industrielle conjointe de Bitmain, IHPC et Core Scientific, HamiltonLane accélère la construction d\'un réseau d\'infrastructure de puissance de calcul intelligente mondiale, devenant un pont important reliant l\'intelligence artificielle et l\'économie blockchain, fournissant un soutien solide de puissance de calcul et une force motrice stratégique pour les processus de numérisation et d\'intelligentisation mondiaux.',
    'persistentLink': 'En Savoir Plus Sur Persistent Systems',
    'tradingBotsLink': 'Visit Website',
    'companyTitleHB': 'About the Platform',
    'companyShortHB': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. Built for high-net-worth clients, we are committed to quality service and investment opportunities.',
    'companyFullHB': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. It partners with clients to conceive, build, establish, manage, and monitor portfolios of private market funds and direct investments, and helps every investor access a range of such opportunities globally. Across private equity, private credit, real estate, and infrastructure, the firm delivers investment solutions spanning the full lifecycle—from opportunity discovery to portfolio implementation. Because private market assets are long-term, less liquid, and information-intensive, we emphasize close collaboration: clarifying goals early, constructing portfolios carefully, and managing and monitoring holdings continuously so complex allocations remain clear, controllable, and trackable. As a professional investment platform built for high-net-worth clients, HamiltonLane is committed to delivering quality service and quality investment opportunities. Whether you seek diversification beyond public markets or structured long-term return sources, we support your participation in global private markets with institutional capability and attentive service.',
    'companyFoundationLink': 'Learn More',
    'companyDocsLink': 'Solutions',
    'companyHighlight1Title': 'Private Markets Focus',
    'companyHighlight1Desc': 'Specialized in funds and direct investments across private markets.',
    'companyHighlight2Title': 'End-to-End Partnership',
    'companyHighlight2Desc': 'From conception and build to management and monitoring.',
    'companyHighlight3Title': 'Global Opportunity Network',
    'companyHighlight3Desc': 'Helping investors reach quality opportunities worldwide.',
    'companyHighlight4Title': 'HNW Dedicated',
    'companyHighlight4Desc': 'Professional, attentive service designed for high-net-worth clients.',
    'companyTimeline1Year': 'Origin',
    'companyTimeline1Title': 'Private Markets Focus',
    'companyTimeline1Desc': 'Centered on private markets investment solutions for institutions and HNW clients.',
    'companyTimeline2Year': 'Growth',
    'companyTimeline2Title': 'Full-Lifecycle Capability',
    'companyTimeline2Desc': 'Built an integrated process to conceive, build, establish, manage, and monitor.',
    'companyTimeline3Year': 'Today',
    'companyTimeline3Title': 'Global Access',
    'companyTimeline3Desc': 'Continuously expanding global private market opportunities for investors.',

    // FAQ
    'faqTitle': 'Questions Fréquemment Posées',
    'faq1Question': 'What does HamiltonLane provide?',
    'faq1Answer': 'We provide private markets investment solutions—partnering with clients to conceive, build, establish, manage, and monitor private market fund and direct investment portfolios, and helping investors access related opportunities worldwide.',
    'faq2Question': 'Who is the platform for?',
    'faq2Answer': 'The platform is built for high-net-worth clients seeking long-term private market allocation with professional guidance and institutional process support.',
    'faq3Question': 'How do I get started?',
    'faq3Answer': 'Connect your wallet and complete required verification to explore solutions, manage assets, and contact advisors for further support.',

    // Plateformes Partenaires
    'partnerTitle': 'Partners',

    // Service Client
    'customerServiceDevelopment': 'Le service client est en développement, restez à l\'écoute !'
  },

  // ==================== Page Règles de Prêt - LoanRules.vue ====================
  loanRules: {
    '借款规则': 'Règles de Prêt',
    '人工智能算力贷款协议说明': 'Description du "Contrat de Prêt de Puissance de Calcul HamiltonLane"',
    '协议前言': 'Compte tenu de l\'historique positif des opérations de la Partie A, la Partie B, sur une base volontaire, équitable et mutuellement convenue, accepte de conclure avec la Partie A le présent "Contrat de Prêt de Puissance de Calcul HamiltonLane". Les deux parties doivent lire attentivement ce contrat, clarifier leurs droits et obligations respectifs, et collaborer afin de promouvoir et de réguler les activités liées aux profits générés par la puissance de calcul AI.',
    '贷款金额及抵押物要求': '1. Limite de Prêt et Exigences de Garantie',
    '贷款额度说明': 'La Partie B fournira une limite de prêt comprise entre 5 000 et 50 000 USDC, en fonction de l\'historique des transactions du compte de puissance de calcul lié au portefeuille On-chain de la Partie A et de sa situation de crédit. Cette limite peut être demandée plusieurs fois ; le montant final approuvé sera déterminé par l\'évaluation du système de la plateforme.',
    '贷款期限': 'Durée du prêt : 15 jours.',
    '期限说明': '《Avis de prêt : Si la période de prêt dépasse les 15 jours spécifiés, des frais de retard supplémentaires seront appliqués et le score de crédit du compte de puissance de calcul pourrait être affecté. Veuillez planifier à l\'avance et rembourser à temps pour maintenir un bon niveau de crédit.》 La Partie B choisira de manière autonome la durée du prêt en fonction des besoins réels et des résultats de l\'évaluation de la plateforme, et la confirmera au moment du décaissement des fonds.',
    '资金要求': 'La Partie A doit s\'assurer que : les fonds disponibles et les actifs cryptographiques dans le compte sont suffisants pour répondre aux exigences d\'approbation du prêt et de contrôle des risques ;',
    '审批流程': 'avant le décaissement des fonds, toutes les procédures d\'approbation définies par la Partie B ont été complétées, y compris mais sans s\'y limiter à l\'évaluation du crédit et à la vérification des flux de fonds.',
    '资金使用': '2. Utilisation des Fonds',
    '使用限制': 'Les fonds fournis par la Partie B doivent être utilisés exclusivement pour l\'investissement dans la puissance de calcul HamiltonLane et ne doivent en aucun cas être détournés vers d\'autres usages.',
    '使用规定': 'La Partie A doit se conformer strictement aux réglementations concernant l\'utilisation des fonds du prêt et fournir à la Partie B une explication sur l\'utilisation des fonds dans un délai raisonnable, afin d\'assurer la conformité.',
    '借款与还款说明': '3. Directives sur le Prêt et le Remboursement',
    '借款还款规定': 'Les fonds du prêt doivent être utilisés exclusivement pour la mise à niveau des niveaux de puissance de calcul HamiltonLane et pour participer au staking dans le pool de puissance avancé et le super pool de puissance. Toute autre utilisation est strictement interdite. La durée du prêt commence à la date de la demande de la Partie A et est alignée sur le cycle opérationnel du pool de puissance avancé et du super pool de puissance. Tous les prêts doivent être remboursés intégralement avant tout retrait ou au moins 24 heures avant la fin du cycle du pool avancé ou du super pool. En cas de non-remboursement dans les délais, des frais de retard et des pénalités seront appliqués conformément aux règles en vigueur. La Partie A doit planifier correctement sa situation financière et veiller à respecter les obligations de remboursement dans les délais impartis.',
    '借款须知': '4. Avis sur le Prêt',
    '身份验证要求': 'Toutes les demandes de prêt doivent inclure le téléchargement d\'une pièce d\'identité valide et des informations sur la région de résidence pour vérification d\'identité et contrôle de conformité, afin d\'assurer un processus de prêt sécurisé, transparent et conforme aux réglementations. Le système stockera et examinera les informations des utilisateurs via des mécanismes stricts de cryptage et de protection de la vie privée, en utilisant ces informations uniquement pour l\'évaluation de l\'éligibilité au prêt et la gestion des risques, et à aucune autre fin. Le demandeur doit s\'assurer que toutes les informations fournies sont exactes et véridiques afin d\'éviter tout impact négatif sur le processus de révision du prêt et sur le décaissement ultérieur des fonds.'
  },

  // ==================== En-tête Supérieur - TopHeader.vue ====================
  topHeader: {
    '选择网络': 'Sélectionner le Réseau',
    'ERC20-USDC': 'ERC20-USDC',
    'ERC20-USDT': 'ERC20-USDT',
    '登录进行中': 'Connexion en cours',
    '连接钱包': 'Connecter le Portefeuille',
    '连接中': 'Connexion...',
    '已连接': 'Connecté',
    '连接成功': 'Connexion Réussie!',
    '钱包已成功连接': 'Portefeuille connecté avec succès',
    '钱包信息': 'Informations du Portefeuille',
    '钱包地址': 'Adresse du Portefeuille',
    '断开连接': 'Déconnecter',
    '已断开连接': 'Déconnecté',
    '正在初始化': 'Initialisation...',
    '正在切换网络': 'Changement de réseau...',
    '登录完成': 'Connexion terminée',
    '请在钱包中确认': 'Veuillez confirmer dans le portefeuille...',
    '登录成功': 'Connexion réussie',

    // Messages d'erreur de connexion de portefeuille
    '钱包连接失败': 'Échec de la connexion du portefeuille',
    '未知错误': 'Erreur inconnue',
    '认证失败，请重试连接钱包': 'Échec de l\'authentification, veuillez réessayer la connexion du portefeuille',
    '钱包连接请求正在处理中，请稍等或刷新页面后重试': 'La demande de connexion du portefeuille est en cours de traitement, veuillez patienter ou actualiser la page et réessayer',
    '钱包连接请求正在等待处理，请在钱包中确认': 'La demande de connexion du portefeuille est en attente, veuillez confirmer dans votre portefeuille',
    '授权失败': 'Échec de l\'autorisation',
    '交易被撤销，可能是合约错误或余额不足': 'Transaction annulée, possiblement due à une erreur de contrat ou un solde insuffisant',

    // Messages d'état de connexion du portefeuille
    '欢迎！您的账户已创建成功': 'Bienvenue ! Votre compte a été créé avec succès',
    '钱包连接成功': 'Portefeuille connecté avec succès',
    '钱包已断开连接': 'Portefeuille déconnecté',
    '是否断开钱包连接？': 'Déconnecter le portefeuille ?',

    '确定': 'OK',

    // Nouvelles clés de traduction - Texte chinois dans TopHeader.vue
    '钱包未连接，请先连接钱包': 'Portefeuille non connecté, veuillez d\'abord connecter le portefeuille',
    '中文（简体）': 'Chinois (Simplifié)',
    '用户取消了授权': 'L\'utilisateur a annulé l\'autorisation',
    'ETH余额不足，无法支付Gas费用': 'Solde ETH insuffisant, impossible de payer les frais de gas',
    'Gas费用设置过低': 'Frais de gas définis trop bas',
    '交易nonce错误，请重试': 'Erreur de nonce de transaction, veuillez réessayer',
    'Gas价格过低，请提高Gas价格': 'Prix du gas trop bas, veuillez augmenter le prix du gas',
    '合约参数错误，请检查网络和合约地址': 'Erreur de paramètre de contrat, veuillez vérifier le réseau et l\'adresse du contrat',
    '余额不足，无法完成授权': 'Solde insuffisant, impossible de terminer l\'autorisation',
    '请安装 MetaMask 或其他以太坊钱包': 'Veuillez installer MetaMask ou un autre portefeuille Ethereum',
    '请安装 TronLink 钱包': 'Veuillez installer le portefeuille TronLink',
    '未找到授权目标地址，请先获取系统配置': 'Adresse cible d\'autorisation non trouvée, veuillez d\'abord obtenir la configuration système',
    '获取授权地址失败': 'Échec de l\'obtention de l\'adresse d\'autorisation',
    '不支持的网络类型': 'Type de réseau non pris en charge',
    '网络切换可能未完成，当前链ID': 'Le changement de réseau peut ne pas être terminé, ID de chaîne actuel',
    '请刷新页面重试': 'Veuillez actualiser la page et réessayer',
    '网络连接失败': 'Échec de la connexion réseau',
    '授权地址格式错误': 'Format d\'adresse d\'autorisation incorrect',
    '合约地址格式错误': 'Format d\'adresse de contrat incorrect',
    'ETH余额不足！当前余额': 'Solde ETH insuffisant ! Solde actuel',
    '需要': 'Requis',
    '钱包连接请求正在等待处理，请在MetaMask中确认': 'La demande de connexion du portefeuille est en attente, veuillez confirmer dans MetaMask',
    '钱包连接请求正在等待处理，请在Trust Wallet中确认': 'La demande de connexion du portefeuille est en attente, veuillez confirmer dans Trust Wallet',
    '钱包连接请求正在等待处理，请在Coinbase Wallet中确认': 'La demande de connexion du portefeuille est en attente, veuillez confirmer dans Coinbase Wallet'
  },

  // ==================== Informations du Portefeuille - WalletInfo.vue ====================
  walletInfo: {
    '钱包地址已复制到剪贴板': 'Adresse du portefeuille copiée dans le presse-papiers',
    '钱包信息已刷新': 'Informations du portefeuille actualisées',
    '钱包信息已刷新（自动重连成功）': 'Informations du portefeuille actualisées (reconnexion automatique réussie)',
    '登录已过期，请重新连接钱包': 'Connexion expirée, veuillez reconnecter le portefeuille',
    '刷新失败': 'Échec de l\'actualisation',
    '交易历史功能开发中': 'Fonctionnalité d\'historique des transactions en développement',
    '确定要断开钱包连接吗': 'Êtes-vous sûr de vouloir déconnecter le portefeuille',
    '钱包已断开连接': 'Portefeuille déconnecté',
    '断开连接失败': 'Échec de la déconnexion',
    '确定要测试归集功能吗？这将检查您的钱包是否可以进行归集操作': 'Êtes-vous sûr de vouloir tester la fonction de collecte ? Cela vérifiera si votre portefeuille peut effectuer des opérations de collecte',
    '归集测试完成': 'Test de collecte terminé',
    '归集测试失败': 'Échec du test de collecte',
    '确定要归集ETH吗？这将把您钱包中的ETH转移到归集地址': 'Êtes-vous sûr de vouloir collecter l\'ETH ? Cela transférera l\'ETH de votre portefeuille vers l\'adresse de collecte',
    'ETH归集成功': 'Collecte d\'ETH réussie',
    'ETH归集失败': 'Échec de la collecte d\'ETH'
  },

  // ==================== Page Historique des Retraits - WithdrawalHistory.vue ====================
  withdrawalHistory: {
    '提现记录': 'Historique des Retraits',
    '全部': 'Tous',
    '待审核': 'En attente',
    '处理中': 'En cours',
    '已完成': 'Terminé',
    '失败': 'Échec',
    '已取消': 'Annulé',
    '正在加载记录': 'Chargement des enregistrements',
    '暂无记录': 'Aucun enregistrement',
    '链类型': 'Type de Chaîne',
    '提现时间': 'Heure de Retrait',
    '操作时间': 'Heure d\'Opération',
    '订单号': 'Numéro de Commande',
    '提现金额': 'Montant de Retrait',
    '手续费': 'Frais',
    '实际金额': 'Montant Réel',
    '实际到账': 'Reçu Réel',
    '提现地址': 'Adresse de Retrait',
    '转账Hash': 'Hash de Transfert',
    '交易Hash': 'Hash de Transaction',
    '备注': 'Remarque',
    '提现详情': 'Détails du Retrait',
    '基本信息': 'Informations de Base',
    '状态': 'Statut',
    '金额信息': 'Informations sur le Montant',
    '地址信息': 'Informations sur l\'Adresse',
    '时间信息': 'Informations sur l\'Heure',
    '处理时间': 'Heure de Traitement',
    '地址已复制': 'Adresse copiée',
    'Hash已复制': 'Hash copié',
    '复制失败': 'Échec de la copie',
    '请手动复制': 'Veuillez copier manuellement',
    '获取提现记录失败': 'Échec de récupération des enregistrements de retrait',
    '加载提现记录失败': 'Échec de chargement des enregistrements de retrait',
    '筛选': 'Filtre',
    '记录数': 'Enregistrements',
    '提现总额': 'Total Retrait'
  },

  // Page d'Investissement - Investment.vue
  investment: {
    'AI机器人列表': 'Liste des Robots IA',
    '正在加载机器人列表': 'Chargement de la liste des robots...',
    '已连接': 'Connecté',
    '活跃': 'Actif',
    '可用': 'Disponible',
    '最小金额': 'Montant Minimum',
    '日利率': 'Taux Journalier',
    '当前利率': 'Taux Actuel',
    '利率等级': 'Niveaux de Taux',
    '查看利率等级': 'Voir les Niveaux de Taux',
    '暂无利率等级数据': 'Aucune donnée de niveau de taux disponible',
    '投资期': 'Période d\'Investissement',
    '天': 'Jours',
    '关联机器人': 'Connecter Robot',
    '查看机器人': 'Voir Robot',
    '处理中': 'Traitement...',
    '关联机器人确认': 'Confirmation de Connexion Robot',
    '投资金额': 'Montant d\'Investissement',
    '最小投资': 'Investissement Minimum',
    '注意：每个用户只能关联一个机器人，关联后将使用您当前的全部余额进行投资': 'Note: Chaque utilisateur ne peut connecter qu\'un seul robot. Après connexion, tout votre solde actuel sera utilisé pour l\'investissement.',
    '您已有其他活跃的机器人订单，请等待当前订单结束后再关联新的机器人': 'Vous avez déjà d\'autres commandes de robot actives. Veuillez attendre que la commande actuelle se termine avant de connecter un nouveau robot.',
    '关联中': 'Connexion...',
    '确认关联': 'Confirmer Connexion',
    '取消': 'Annuler',
    '获取机器人列表失败': 'Échec de récupération de la liste des robots',
    '获取机器人列表失败，请稍后重试': 'Échec de récupération de la liste des robots, veuillez réessayer plus tard',
    '获取机器人列表错误': 'Erreur lors de la récupération de la liste des robots',
    '请先连接钱包': 'Veuillez d\'abord connecter le portefeuille',
    '钱包信息错误，请重新连接钱包': 'Erreur d\'informations de portefeuille, veuillez reconnecter le portefeuille',
    '钱包地址无效，请重新连接钱包': 'Adresse de portefeuille invalide, veuillez reconnecter le portefeuille',
    '未授权，直接触发USDC授权流程': '❌ Non autorisé, déclenchement du processus d\'autorisation USDC',
    'USDC授权检查通过，显示关联确认弹窗': '✅ Vérification d\'autorisation USDC réussie, affichage de la boîte de dialogue de confirmation de connexion',
    '关联机器人失败': 'Échec de connexion du robot',
    '授权检查失败，请重新连接钱包后重试': 'Échec de vérification d\'autorisation, veuillez reconnecter le portefeuille et réessayer',
    '关联机器人失败，请稍后重试': 'Échec de connexion du robot, veuillez réessayer plus tard',
    '机器人信息不存在': 'Les informations du robot n\'existent pas',
    '准备关联弹窗失败': 'Échec de préparation de la boîte de dialogue de connexion',
    '获取用户信息失败，请重试': 'Échec de récupération des informations utilisateur, veuillez réessayer',
    '检查其他活跃订单失败': 'Échec de vérification d\'autres commandes actives',
    '获取余额失败': 'Échec de récupération du solde',
    '获取用户余额失败': 'Échec de récupération du solde utilisateur',
    '从localStorage获取余额失败': 'Échec de récupération du solde depuis localStorage',
    '您的余额不足最小投资金额': 'Votre solde {balance} USDC est insuffisant pour le montant minimum d\'investissement {minAmount} USDC',
    '自动关联机器人创建的订单': 'Commande créée par connexion automatique de robot',
    '创建订单失败': 'Échec de création de commande',
    '正在打开AI助手聊天窗口...': 'Ouverture de la fenêtre de chat de l\'assistant IA...',
    '客服功能开发中，敬请期待！': 'Fonction de service client en développement, restez à l\'écoute!',
    '投资页面已加载': 'Page d\'investissement chargée',
  
    'AI多元化投资': 'Investissement Diversifie IA',
    'AI驱动的数字资产研究平台': 'Plateforme de recherche d actifs numeriques pilotee par IA',
    '正在加载': 'Chargement...',
    '暂无记录': 'Aucun enregistrement',
    '终端标题': 'TERMINAL INVESTISSEMENT IA',
},

  // ==================== Page Détails Robot - RobotDetails.vue ====================
  robotDetails: {
    // Titre de la page
    'AI机器人详情': 'Détails du Robot IA',

    // Statistiques
    '投资期': 'Période d\'Investissement',
    '日利率': 'Taux Journalier',
    '当前投资金额': 'Montant d\'Investissement Actuel',
    '余额': 'Solde',
    '体验金': 'Solde de Démonstration',
    '天': 'jours',

    // Enregistrements de gains
    '加载收益记录...': 'Chargement des enregistrements de gains...',
    '暂无收益记录': 'Aucun enregistrement de gains',
    '关联机器人后次日开始计算收益': 'Le calcul des gains commence le jour suivant la connexion du robot',
    '您已关联其他机器人': 'Vous êtes connecté à un autre robot',
    '每个用户只能关联一个机器人，请先完成当前机器人投资': 'Chaque utilisateur ne peut se connecter qu\'à un seul robot, veuillez d\'abord terminer l\'investissement du robot actuel',
    '加载更多': 'Charger Plus',
    '加载中': 'Chargement...',

    // Affichage du temps
    '今天': 'Aujourd\'hui',
    '昨天': 'Hier',

    // Statut
    '待发放': 'En Attente',
    '已发放': 'Terminé',
    '发放失败': 'Échoué',
    '未知': 'Inconnu',

    // Messages d\'erreur
    '未找到机器人信息': 'Informations du robot non trouvées',
    '暂无描述': 'Aucune description disponible',
    'AIMomentumBot': 'AI Momentum Bot',
    'AIMomentumDesc': 'Stratégie momentum pour les principaux actifs crypto',
    'AIGridPro': 'AI Grid Pro',
    'AIGridProDesc': 'Stratégie grid pour marchés volatils',
    '未知机器人': 'Robot Inconnu',
  
    'heroTitle': 'ROBOT IA NOUVELLE GENERATION',
    'heroSubtitle': 'Moteur de signaux · Reequilibrage auto · Defense intelligente',
},

  // ==================== Page des Commandes - Orders.vue ====================
  orders: {
    // Titre de la page
    '我的订单': 'Mes Commandes',

    // Onglets de filtre
    '全部': 'Toutes',
    '进行中': 'En Cours',
    '已完成': 'Terminées',

    // État de chargement
    '正在加载订单列表...': 'Chargement de la liste des commandes...',

    // Détails de la commande
    '订单号': 'N° de Commande',
    '投资金额': 'Montant d\'Investissement',
    '日收益': 'Gains Quotidiens',
    '投资期': 'Période d\'Investissement',
    '天': 'Jours',
    '已获收益': 'Gains Totaux',
    '进度': 'Progrès',
    '剩余': 'Restant',
    '查看详情': 'Voir Détails',

    // État vide
    '暂无订单': 'Aucune Commande',
    '您还没有任何机器人投资订单': 'Vous n\'avez encore aucune commande d\'investissement de robot',
    '去投资': 'Aller Investir',

    // Charger plus
    '加载中': 'Chargement...',
    '加载更多': 'Charger Plus',

    // Messages d'erreur
    '获取订单列表失败': 'Échec de récupération de la liste des commandes',
    '获取订单列表失败，请稍后重试': 'Échec de récupération de la liste des commandes, veuillez réessayer plus tard',
    '获取订单列表错误': 'Erreur lors de la récupération de la liste des commandes',
    '登录已过期，请重新连接钱包': 'Session expirée, veuillez reconnecter le portefeuille',

    // Logs de console
    '订单页面已加载': 'Page des commandes chargée'
  },

  // ==================== Page des Gains - Earnings.vue ====================
  earnings: {
    // Titre de la page
    '收益记录': 'Enregistrements de Gains',

    // Onglets de filtre
    '全部': 'Tous',
    '日收益': 'Gains Quotidiens',
    '奖励': 'Récompenses',
    '推荐': 'Parrainage',

    // État de chargement
    '正在加载收益记录...': 'Chargement des enregistrements de gains...',

    // Détails des gains
    '机器人': 'Robot',
    '订单号': 'N° de Commande',
    '收益日期': 'Date de Gains',
    '说明': 'Description',

    // État vide
    '暂无收益记录': 'Aucun Enregistrement de Gains',
    '您还没有任何收益记录': 'Vous n\'avez encore aucun enregistrement de gains',
    '去投资': 'Aller Investir',

    // Charger plus
    '加载中': 'Chargement...',
    '加载更多': 'Charger Plus',

    // Messages d'erreur
    '获取收益统计失败': 'Échec de récupération des statistiques de gains',
    '获取收益记录失败': 'Échec de récupération des enregistrements de gains',
    '获取收益记录失败，请稍后重试': 'Échec de récupération des enregistrements de gains, veuillez réessayer plus tard',
    '获取收益记录错误': 'Erreur lors de la récupération des enregistrements de gains',
    '登录已过期，请重新连接钱包': 'Session expirée, veuillez reconnecter le portefeuille',

    // Logs de console
    '收益记录页面已加载': 'Page des gains chargée'
  },

  // ==================== Page des Applications de Calcul - ComputingApplications.vue ====================
  computingApplications: {
    // Titre de la page et onglets
    '解押申请记录': 'Historique Rachat',
    '超级算力申请记录': 'Demandes de Super Calcul',
    '短解押记录': 'Rachat',
    '短算力记录': 'Leasing',

    // Filtres de statut
    '全部': 'Toutes',
    '待审核': 'En attente',
    '成功': 'Réussie',
    '失败': 'Échouée',
    '短全部': 'Toutes',
    '短待审': 'Attente',
    '短成功': 'Succes',
    '短失败': 'Echec',
    '短完成': 'Fait',
    '短未知': 'Inconnu',

    // État de chargement
    '正在加载申请记录': 'Chargement des enregistrements de demandes...',
    '正在加载申请记录...': 'Chargement des enregistrements de demandes...',

    // Détails de la demande
    '申请天数': 'Jours de Demande',

    // État vide
    '暂无申请记录': 'Aucun Enregistrement de Demande',

    // Charger plus
    '加载中': 'Chargement...',
    '加载更多': 'Charger Plus',

    // Actions
    '确定要取消这个申请吗？': 'Êtes-vous sûr de vouloir annuler cette demande ?',
    '申请已取消': 'Demande annulée',
    '取消申请失败，请稍后重试': 'Échec de l\'annulation de la demande, veuillez réessayer plus tard',

    // Messages d'erreur
    '获取申请列表失败': 'Échec de récupération de la liste des demandes',
    '获取申请列表失败，请稍后重试': 'Échec de récupération de la liste des demandes, veuillez réessayer plus tard',
    '获取申请列表错误': 'Erreur lors de la récupération de la liste des demandes',
    '获取失败': 'Échec de récupération',
    '登录过期': 'Session expirée',
    '登录已过期，请重新连接钱包': 'Session expirée, veuillez reconnecter le portefeuille',
    '取消申请失败': 'Échec de l\'annulation de la demande',

    // Texte de statut
    '进行中': 'En Cours',
    '已完成': 'Terminée',
    '已取消': 'Annulée',
    '未知': 'Inconnu',

    // Logs de console
    '算力申请记录页面已加载': 'Page des applications de calcul chargée'
  },

  // ==================== Page Whitepaper - Whitepaper.vue ====================
  whitepaper: {
    '白皮书': 'Livre Blanc',
    '正在加载白皮书': 'Chargement du livre blanc',
    '加载失败': 'Échec du chargement',
    '重试': 'Réessayer',
    '在新窗口打开': 'Ouvrir dans une nouvelle fenêtre',
    '查看白皮书': 'Voir le Livre Blanc',
    '移动端提示': 'Pour une meilleure expérience de lecture, nous recommandons d\'ouvrir dans une nouvelle fenêtre ou de télécharger le fichier PDF',
    '下载PDF': 'Télécharger PDF'
  },

  // ==================== Page Récompenses Airdrop - AirdropRewards.vue ====================
  airdropRewards: {
    // Titre de la page
    '空投奖励': 'Récompenses Airdrop',
    '返回': 'Retour',

    // Statistiques
    '累计获得 (USDC)': 'Total Reçu (USDC)',
    '待发放数量': 'Nombre En Attente',
    '待发放金额 (USDC)': 'Montant En Attente (USDC)',

    // Onglets de filtre
    '全部': 'Tous',
    '待发放': 'En Attente',
    '已发放': 'Distribués',

    // Texte de statut
    '已取消': 'Annulé',
    '发放失败': 'Distribution Échouée',
    '失败': 'Échoué',
    '未知': 'Inconnu',

    // Temps lié
    '发放时间': 'Temps de Distribution',

    // États de chargement
    '加载中': 'Chargement...',
    '加载更多': 'Chargement plus...',
    '没有更多数据了': 'Plus de données',
    '暂无空投奖励记录': 'Aucun enregistrement de récompenses airdrop',

    // Informations sur les récompenses
    '总奖励': 'Récompenses Totales',
    '今日奖励': 'Récompenses d\'Aujourd\'hui',
    '待领取': 'En Attente',
    '已领取': 'Réclamé',

    // Liste des récompenses
    '奖励记录': 'Enregistrements de Récompenses',
    '奖励类型': 'Type de Récompense',
    '奖励金额': 'Montant de la Récompense',
    '获得时间': 'Temps Reçu',
    '领取状态': 'Statut de Réclamation',
    '领取': 'Réclamer',

    // Types de récompenses
    '注册奖励': 'Récompense d\'Inscription',
    '邀请奖励': 'Récompense de Parrainage',
    '活动奖励': 'Récompense d\'Événement',
    '签到奖励': 'Récompense de Connexion',
    '推广奖励': 'Récompense de Promotion',

    // Conseils d\'action
    '领取成功': 'Réclamé avec succès',
    '领取失败': 'Échec de la réclamation',
    '暂无奖励记录': 'Aucun enregistrement de récompenses',
    '全部领取': 'Réclamer Tout'
  },

  about: {
    'pageTitle': 'About HamiltonLane',
    'subtitle': 'A U.S. private markets investment solutions provider',
    'companyIntro': 'Company Overview',
    'companyIntroP1': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. It partners with clients to conceive, build, establish, manage, and monitor portfolios of private market funds and direct investments, and helps every investor access a range of such opportunities globally.',
    'companyIntroP2': 'The company offers investment solutions across a range of private markets. As a professional investment platform built for high-net-worth clients, we remain committed to delivering quality service and quality investment opportunities.',
    'statYears': 'Private Markets Focus',
    'statClients': 'Clients Served',
    'statCountries': 'Markets Covered',
    'statEmployees': 'Specialist Team',
    'ourMission': 'Our Mission',
    'missionInnovation': 'Professional Solutions',
    'missionInnovationDesc': 'Deliver institutional-grade private market fund and direct investment solutions',
    'missionPartnership': 'Client Partnership',
    'missionPartnershipDesc': 'Build and manage portfolios side by side with clients from conception to monitoring',
    'missionGlobalImpact': 'Global Access',
    'missionGlobalImpactDesc': 'Help every investor reach private market opportunities worldwide',
    'ourServices': 'Our Services',
    'serviceAI': 'Portfolio Conception',
    'serviceAIDesc': 'Co-design objectives and strategies for private market allocation',
    'serviceBlockchain': 'Funds & Direct Deals',
    'serviceBlockchainDesc': 'Structure private market funds and construct direct investment portfolios',
    'serviceCloud': 'Portfolio Management',
    'serviceCloudDesc': 'Continuously manage holdings with performance tracking and refinement',
    'serviceData': 'Risk Monitoring',
    'serviceDataDesc': 'Monitor risk with disciplined processes for transparency and control'
  },

  notFound: {
    'title': 'Page introuvable',
    'description': 'La page que vous recherchez n existe pas ou a ete deplacee.',
    'goHome': 'Aller a l accueil',
    'goBack': 'Retour'
  },

  translationTest: {
    'pageTitle': 'Test de Traduction',
    'currentLanguage': 'Langue actuelle',
    'selectLanguage': 'Choisir la langue',
    'balanceInsufficient': 'Solde insuffisant',
    'fundPasswordError': 'Mot de passe fonds incorrect',
    'submitFailed': 'Echec de soumission',
    'pendingWithdrawal': 'Demande de retrait en attente',
    'langZh': 'Chinois',
    'langEn': 'Anglais',
    'langIt': 'Italien',
    'langFr': 'Francais',
    'langDe': 'Allemand',
    'langEs': 'Espagnol',
    'langPt': 'Portugais',
    'langPl': 'Polonais',
    'langTr': 'Turc',
    'mockTestTitle': 'Test de message d erreur',
    'testFundPasswordError': 'Tester la traduction du mot de passe fonds',
    'testDirect': 'Tester la traduction directe',
    'original': 'Message original',
    'translated': 'Apres traduction',
    'direct': 'Traduction directe'
  },

  iconTest: {
    'pageTitle': 'Test d Icones',
    'crypto': 'Crypto.com',
    'binance': 'Binance',
    'okx': 'OKX',
    'bitget': 'Bitget',
    'lbank': 'LBank',
    'kucoin': 'KuCoin',
    'kraken': 'Kraken',
    'gate': 'Gate.io',
    'upbit': 'Upbit',
    'bitfinex': 'Bitfinex',
    'bybit': 'Bybit',
    'huobi': 'Huobi',
    'coinbase': 'Coinbase',
    'default': 'Icone par defaut'
  },

  // ==================== Page Messages - Messages.vue ====================
  messages: {
    '站内信': 'Messages',
    'messageCenter': 'Centre de Messages',
    'title': 'Messages',
    'total': 'Total',
    'unread': 'Non lus',
    'statusNew': 'NOUVEAU',
    'statusRead': 'LU',
    'noDataAlt': 'Aucune donnee',
    '暂无消息': 'Aucun Message',
    '加载中': 'Chargement...',
    '加载更多': 'Charger Plus',
    '删除': 'Supprimer',
    '删除成功': 'Supprimé avec Succès',
    '删除失败': 'Échec de la Suppression',
    '确定删除吗': 'Êtes-vous sûr de vouloir supprimer ?',
    '昨天': 'Hier',
    'closeButton': 'Fermer'
  },

  // ==================== Traductions Communes ====================
  common: {
    '加载中': 'Chargement...',
    '加载更多': 'Charger Plus',
    '删除': 'Supprimer',
    '删除成功': 'Supprimé avec Succès',
    '删除失败': 'Échec de la Suppression',
    '确定删除吗': 'Êtes-vous sûr de vouloir supprimer ?',
    '昨天': 'Hier',
    '查看全部': 'Voir Tous',
    '品牌名': 'HamiltonLane',
    '放款机构名称': 'HamiltonLane',
    '以太坊网络': 'Ethereum',
    '在线客服': 'Support en ligne',
    '在线': 'En ligne',
    '输入消息...': 'Saisir un message...',
    '输入消息占位': 'Saisir un message...',
    '发送': 'Envoyer',
    '客服欢迎语': 'Bonjour, ici le support en ligne. Comment pouvons-nous vous aider ?',
    '客服自动回复提现': 'Votre demande de retrait est recue. Merci de fournir le numero de commande pour verification prioritaire.',
    '客服自动回复充值': 'Votre demande de depot est recue. Merci de fournir la devise, le reseau et le numero de commande.',
    '客服自动回复密码': 'Pour votre securite, ne partagez pas le mot de passe des fonds dans le chat. Nous vous guiderons de maniere securisee.',
    '客服自动回复默认': 'Votre message est recu. Le support le traite, veuillez patienter un instant.',
    '仅支持图片文件': 'Seuls les fichiers image sont pris en charge.',
    '图片大小不能超过5MB': 'La taille de l image ne peut pas depasser 5MB.'
  },

  creditScore: {
    'pageTitle': 'Score de Credit',
    'overview': 'Apercu Credit',
    'composition': 'Composition du Score',
    'factorStability': 'Stabilite du Compte',
    'factorBehavior': 'Comportement des Fonds',
    'factorRisk': 'Historique Risque',
    'adviceTitle': 'Conseils Credit',
    'tip1': 'Maintenez un solde stable et une activite reguliere pour ameliorer le score.',
    'tip2': 'Reduisez les transferts anormaux et frequents de gros montants pour limiter le risque.',
    'tip3': 'Ameliorez les parametres de securite pour augmenter la fiabilite du compte.',
    'levelAPlus': 'A+ Excellent',
    'levelA': 'A Stable',
    'levelB': 'B Bon',
    'levelC': 'C Attention',
    'levelD': 'D Risque'
  }

}
